import React, { useState, useEffect, useRef } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Button } from "reactstrap";
import { contvertHTMLToPlain } from "../../utils/constants";
import MyLinkModule from "./MyQuillModule";
import "./quilTextEditor.css";
import {connect} from "react-redux"
import { applyCustomFontStyles } from "../../pages/trivia/data";
Quill.register("modules/myLinkModule", MyLinkModule);


 function QuizTextEditor({
  styles,
  value,
  onChange,
  placeholder,
  blockId,
  hideToolbar,
  questionId,
  disabled,
  maxLimit,
  isMessaging,
  allowHyperlink,
  currentTrivia,
  questionThemeSettings
}) {
  const quillRef = useRef(null);
  const [htmlVal, setHtmlVal] = useState(value);
  const [cursorPosition, setCursorPosition] = useState(null);
  useEffect(() => {
    setHtmlVal(value);
  }, [questionId && questionId, value]);

 
  const handlePaste = (e) => {
    if (!quillRef.current) return;

    // setTimeout(()=>{
    //   setHtmlVal(contvertHTMLToPlain(htmlVal))
    //   onChange(contvertHTMLToPlain(htmlVal))
    // },1000)

    // const clipboardData = e.clipboardData || window.clipboardData;
    // console.log(clipboardData,e)
    // const pastedText = clipboardData.getData("text/plain");
    // const selection = quillRef.current.getEditor().getSelection();
    // if (selection) {
    //   quillRef.current.getEditor().clipboard.dangerouslyPasteHTML(
    //     selection.index,
    //     pastedText,
    //     "api"
    //   );
    //   quillRef.current.getEditor().setSelection(selection.index + pastedText.length, 0);
    // }
    // e.preventDefault();
  };

  const handleKeyDown = (e) => {
    if (e.key === "v" && (e.metaKey || e.ctrlKey)) {
      // Detect paste (Ctrl+V or Cmd+V)
      handlePaste(e);
    }
  };



  const htmlLength = htmlVal ? htmlVal.replace(/<[^>]+>/g, "").length : 0;

  return (
    <div
      style={{ position: "relative", ...styles }}
      className="quill-rte-main-wrapper"
    >
      {maxLimit ? (
        <span className="font-11px">
          {htmlLength}/{maxLimit} {isMessaging?'(Message content)':''}
        </span>
      ) : (
        ""
      )}
      <div
        id={blockId ? `quill_toolbar_${blockId}` : `quill_toolbar`}
        style={{ ...(disabled && { display: "none" }) }}
      >
        <button
          style={{ display: !hideToolbar ? "block" : "none" }}
          className="ql-bold"
        ></button>
        <button
          style={{ display: !hideToolbar ? "block" : "none" }}
          className="ql-italic"
        ></button>
        <button
          style={{ display: !hideToolbar ? "block" : "none" }}
          className="ql-underline"
        ></button>
        <button
          style={{ display: !hideToolbar ? "block" : "none" }}
          className="ql-list"
          value="ordered"
        ></button>
        <button
          style={{ display: !hideToolbar ? "block" : "none" }}
          className="ql-list"
          value="bullet"
        ></button>
        {allowHyperlink && (
          <button
            style={{ display: !hideToolbar ? "block" : "none" }}
            className="ql-link"
          ></button>
        )}
      </div>

      {cursorPosition}

      <ReactQuill
        modules={{
          toolbar: hideToolbar
            ? false
            : blockId
            ? `#quill_toolbar_${blockId}`
            : `#quill_toolbar`,
          clipboard: {
            newLines: false,
          },
          ...(allowHyperlink && {
            myLinkModule: {},
          })
          
        }}
        
        ref={quillRef}
        value={htmlVal}
        onChange={(value, delta, source, editor) => {
          console.log(editor);
          if (source === "user" || source ==="api") {
            const plainVal = contvertHTMLToPlain(value || "<p></p>");
            if(value==="<p><br></p>"){
              setHtmlVal("");
              onChange("");
            }else{
              if (maxLimit && plainVal.length > maxLimit) {
                value = contvertHTMLToPlain(value).slice(0, maxLimit);
                setHtmlVal(value);
                onChange(value);
              } else {
                setHtmlVal(value);
                onChange(value);
              }
            }
          }
        }}
        placeholder={placeholder}
        readOnly={disabled}
        formats={[
          'font', 'header', 'bold', 'italic', 'underline', 'strike', 'list', 'bullet', 'link'
        ]}
        // onKeyUp={handleKeyUp}
        // onKeyPress={handleKeyPress}
        style={{
          ...applyCustomFontStyles(questionThemeSettings)
        }}
      />
    </div>
  );
}


const mapStateToProps = (state) => {
  return {
    currentTrivia: state.trivia.currentTrivia,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuizTextEditor);
